export default __webpack_public_path__ + "static/23a9b848f82d72eb62230f89ea26db56.png";